import React, { useEffect, useState } from "react";
import { Box, Card, CardContent} from "@mui/material";
import { Button, DateField,  FunctionField, SimpleShowLayout, TopToolbar, useGetOne, useNotify, useRedirect } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import { Link, useParams } from "react-router-dom";
import { DownloadFile, getNameAndCompanyNamewithAddress, getResource } from "../common";
import { TrashButton } from "../components";

const EstimateHistoryShow = () => {
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams(); 
  const [customers,setCustomers]=useState([]);
  const redirect = useRedirect();
  const [files,setFiles] = useState(null);
  const notify = useNotify();

  const { data, isLoading } = useGetOne("estimateHistory", { id });
  useEffect(() => {
    if(!isLoading && data){
      setRecord(data);
    }
  },[data,isLoading]);

  useEffect(() => {
    const getCustomers = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/all`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };
    getCustomers();
  }, []);

  useEffect(()=>{
    if(record){
      const fetchFiles = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_DIR}/documents/estimate/${record.estimateId}`,{
            method: "GET",
            headers: new Headers({ "Content-Type": "application/json" }),
            mode: "cors",
            credentials: "include",
          });
          const data = await response.json();
          if (data.files) {
            setFiles(data.files);
          }
        } catch (error) {
          console.error("ファイル一覧の取得に失敗しました:", error);
          notify("ファイル一覧の取得に失敗しました",{type:"error"});
        }
      };
      fetchFiles();
    }
  },[record]);

  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, margin: 0 }}>
        <TopToolbar>
            <Button
                label="見積情報編集"
                onClick={() => redirect(`/estimateHistory/${id}`)}
                startIcon={<EditIcon />}
            />
        </TopToolbar>
    </Box>
  );

  const labelStyle = (text) => (
    <div style={{ backgroundColor: "#eee", color: "#666", paddingLeft: "5px" }}>
      {text}
    </div>
  );

  const handleDelete = (filePath) => {
    const deleteFile = async (filePath) => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/documents`,{
          method: "DELETE",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
          body: JSON.stringify({filePath}),
        });
        const data = await response.json();
        if (data.isError) {
          notify(data.message || "エラーが発生しました",{type:"error"});
        }
        else{
          notify("削除されました",{type:"sccuess"});
          window.location.reload();
        }
      } catch (error) {
        notify("エラーが発生しました",{type:"error"});
      }
    };
    deleteFile(filePath);
  };

  return (
    <>
      <CustomTopToolbar/>
      <Card>
        <CardContent>
          <SimpleShowLayout record={record}>
            {/* <FunctionField source="number" label={labelStyle("見積No")} style={{ paddingLeft: "5px" }} render={(record) => {
              return String(record.number).padStart(5, "0");
            }}/> */}
            <DateField source="createEstimateDate" label={labelStyle("見積作成日")} style={{ paddingLeft: "5px" }}/>
            <DateField source="requestEstimateDate" label={labelStyle("見積依頼日")} style={{ paddingLeft: "5px" }} />
            <FunctionField source="estimateAmount" label={labelStyle("見積金額(税抜き)")}
              render={(record) => {
                return record.estimateAmount ? `${record.estimateAmount.toLocaleString()}円` : ""
              }}
              style={{ paddingLeft: "5px" }}
            />
            <FunctionField source="createrName" label={labelStyle("見積作成者")} style={{ paddingLeft: "5px" }} render={record => {return record.createrName}} />
            <FunctionField
              source="customerId"
              label={labelStyle("顧客名")} style={{ paddingLeft: "5px" }}
              render={(record) => {
                const customer = customers.find(req => req.id === record.customerId);
                return customer ? <Link to={`/${getResource(customer)}/show/${record.customerId}`}>{getNameAndCompanyNamewithAddress(customer)}</Link> : "";
              }}
            />
            <FunctionField
              source="documentURL"
              label={labelStyle("見積書ファイル")}
              render={(record) => (
                <div style={{ paddingLeft: "5px",margin:"0" }}>
                  {files && files.length > 0 ? (
                    <>
                      {files.map((file, index) => (
                        <div key={index}>
                          <Link onClick={() => DownloadFile(file.url)} >{file.name}</Link>
                          <TrashButton onDelete={() => handleDelete(file.url)} />
                        </div>
                      ))}
                    </>
                  ) : null}
                </div>
              )}
            />
          </SimpleShowLayout>
        </CardContent>
      </Card>
    </>

  );
};

export default EstimateHistoryShow;

